/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIOffer } from './APIOffer';
import {
    APIOfferFromJSON,
    APIOfferFromJSONTyped,
    APIOfferToJSON,
} from './APIOffer';

/**
 * 
 * @export
 * @interface APIPaginatedOfferList
 */
export interface APIPaginatedOfferList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedOfferList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedOfferList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedOfferList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APIOffer>}
     * @memberof APIPaginatedOfferList
     */
    results: Array<APIOffer>;
}

/**
 * Check if a given object implements the APIPaginatedOfferList interface.
 */
export function instanceOfAPIPaginatedOfferList(value: object): value is APIPaginatedOfferList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedOfferListFromJSON(json: any): APIPaginatedOfferList {
    return APIPaginatedOfferListFromJSONTyped(json, false);
}

export function APIPaginatedOfferListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedOfferList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APIOfferFromJSON)),
    };
}

export function APIPaginatedOfferListToJSON(value?: APIPaginatedOfferList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APIOfferToJSON)),
    };
}

